const IST = 'Asia/Kolkata';
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Calendar date of a stored action date, in India time.
// Form-saved dates ("2026-11-05T20:00:59Z") carry the India wall-clock tagged Z, so the date part is used as-is;
// server-generated dates ("…+00:00") are real instants and are converted to India time.
export const istDateParts = (value) => {
  if (!value) return null;
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?Z$/.test(s) || /^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.slice(0, 10).split('-').map(Number);
    return { y, m, d };
  }
  const dt = new Date(s);
  if (Number.isNaN(dt.getTime())) return null;
  const [y, m, d] = new Intl.DateTimeFormat('en-CA', { timeZone: IST, year: 'numeric', month: '2-digit', day: '2-digit' })
    .format(dt).split('-').map(Number);
  return { y, m, d };
};

const fmt = (p, withYear = true) => `${p.d} ${MONTHS[p.m - 1]}${withYear ? ` ${p.y}` : ''}`;

// "5 Nov 2026" for one-time actions; "5 Nov – 7 Nov 2026" for multi-day ones.
export const formatActionDates = (challenge) => {
  const start = istDateParts(challenge?.start_date);
  if (!start) return '';
  const end = istDateParts(challenge?.end_date);
  const sameDay = !end || (end.y === start.y && end.m === start.m && end.d === start.d);
  if (challenge?.challenge_type === 'specific-time' || sameDay) return fmt(start);
  return `${fmt(start, start.y !== end.y)} – ${fmt(end)}`;
};

// Location text to show, or null to hide the row. Server-suggested placeholders are not real locations.
export const displayLocation = (challenge) => {
  if (challenge?.is_online) return 'Online';
  if (challenge?.location && !challenge.location_auto_generated) return challenge.location;
  return null;
};
